@if (showSplash) {
  <app-splash-screen [@enterLeaveAnimation]></app-splash-screen>
} @else {
  <ion-app>
    <ion-router-outlet></ion-router-outlet>
  </ion-app>
}
